import { connect } from 'react-redux'

import RegisterWidgetLayoutTwo from 'components/home-page/views/sections/register-widget/layouts/two'

const mapStateToProps = (state, ownProps) => ({
  data: state.homePageRevision.revision.sections[ownProps.sectionId].data[0],
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(RegisterWidgetLayoutTwo)
